import React from "react";

import { AiOutlineClose } from "react-icons/ai";

import axiosInstance from "../services/axiosInstance";
import { useState } from "react";

const EditDentistDetailPopup = ({
  getDentistList,
  dentistList,
  dentist,
  setDentist,
  openPopUp,
  closePopUp,
}) => {
  const [errors, setErrors] = useState({});

  const handleClosePopUp = () => {
    closePopUp();
    setErrors({});
  };

  if (openPopUp !== true) return null;

  const saveDentistDetails = async () => {
    if (validateForm()) {
      const response = await axiosInstance.post(
        "/api/Dentist/updateDentistDetails",
        dentist
      );

      if (response.isSuccess) {
        getDentistList();
      }
      handleClosePopUp();
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!dentist.dentistCode.trim()) {
      newErrors.dentistCode = "Dentist Code is required.";
    } else if (
      dentistList.filter(
        (x) => x.dentistCode === dentist.dentistCode.trim() && x.dentistId !== dentist.dentistId
      ).length >= 1
    ) {
      newErrors.dentistCode = "Dentist Code already exist.";
    }
    if (!dentist.practiceName.trim())
      newErrors.practiceName = "Practice Name is required.";
    if (!dentist.dentistName.trim())
      newErrors.dentistName = "Praxis Name erforderlich.";
    if (!dentist.dentistDisplayName.trim()) {
      newErrors.dentistDisplayName = "Dentist Display Name is required.";
    } else if (
      dentistList.filter(
        (x) =>
          x.dentistDisplayName === dentist.dentistDisplayName.trim() &&
          x.dentistId !== dentist.dentistId
      ).length >= 1
    ) {
      newErrors.dentistDisplayName = "Dentist display name already exist.";
    }
    if (!dentist.geoCode.trim()) {
      newErrors.geoCode = "Geo Code is required.";
    } else if (dentist.geoCode.trim().length > 3) {
      newErrors.geoCode = "Invalid Geo Code.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div
      id="ModelContainer"
      className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-50 overflow-auto"
    >
      <div className="flex justify-center items-center py-10">
        <div className="relative bg-white w-5/6 md:w-[730px] mx-auto rounded-[30px] p-20 pt-14 shadow-[0_0_7px_rgba(92,92,92,0.35)] drop-shadow-[0_0_4px_rgba(178,178,178,0.2)">
          <a
            className="absolute right-8 top-8 text-4xl text-gray-500 pointer"
            id="closePopup"
            onClick={handleClosePopUp}
          >
            <AiOutlineClose />
          </a>
          <div className="w-full">
            <p className="font-interBold text-blue-600 py-7 text-3xl">
              Details bearbeiten
            </p>
            <div>
              {/* Dentist Code */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Dentist Code
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-4 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="Dentist Code"
                    value={dentist.dentistCode}
                    onChange={(e) =>
                      setDentist((prev) => ({
                        ...prev,
                        dentistCode: e.target.value,
                      }))
                    }
                  />
                  {errors.dentistCode && (
                    <p className="text-red text-sm mt-1">
                      {errors.dentistCode}
                    </p>
                  )}
                </div>
              </div>

              {/* Practice Name */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Practice Name
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="Practice Name"
                    value={dentist.practiceName}
                    onChange={(e) =>
                      setDentist((prev) => ({
                        ...prev,
                        practiceName: e.target.value,
                      }))
                    }
                  />
                  {errors.practiceName && (
                    <p className="text-red text-sm mt-1">
                      {errors.practiceName}
                    </p>
                  )}
                </div>
              </div>

              {/* Dentist Name */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Dentist Name
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="Praxis"
                    value={dentist.dentistName}
                    onChange={(e) =>
                      setDentist((prev) => ({
                        ...prev,
                        dentistName: e.target.value,
                      }))
                    }
                  />
                  {errors.dentistName && (
                    <p className="text-red text-sm mt-1">
                      {errors.dentistName}
                    </p>
                  )}
                </div>
              </div>

              {/* Dentist Display Name */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Dentist Display Name
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="Dentist Display Name"
                    value={dentist.dentistDisplayName}
                    onChange={(e) =>
                      setDentist((prev) => ({
                        ...prev,
                        dentistDisplayName: e.target.value,
                      }))
                    }
                  />
                  {errors.dentistDisplayName && (
                    <p className="text-red text-sm mt-1">
                      {errors.dentistDisplayName}
                    </p>
                  )}
                </div>
              </div>

              {/* Geo Code */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Geo Code
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="Geo Code"
                    value={dentist.geoCode}
                    onChange={(e) =>
                      setDentist((prev) => ({
                        ...prev,
                        geoCode: e.target.value,
                      }))
                    }
                  />
                  {errors.geoCode && (
                    <p className="text-red text-sm mt-1">{errors.geoCode}</p>
                  )}
                </div>
              </div>

              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  PP_Notes
                </label>
                <input
                  className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                  type="text"
                  value={dentist?.pP_Notes}
                  onChange={(e) => {
                    setDentist((prevUser) => ({
                      ...prevUser,
                      pP_Notes: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
            <div className="mt-5 flex items-center justify-end gap-5">
              <button
                className="px-5 py-2 border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
                onClick={handleClosePopUp}
              >
                Abbrechen
              </button>
              <button
                className="bg-blue uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in leading-relaxed"
                type="button"
                onClick={saveDentistDetails}
              >
                Speichern
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDentistDetailPopup;
